module.exports = __webpack_public_path__ + "img/gonglve.5aab412e.png";